var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-bar"},[_c('a',{attrs:{"href":"/"}},[_c('Logo',{attrs:{"variant":"box"}}),_c('div',{staticClass:"logo-text"},[_vm._v(_vm._s(_vm.text))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }